module.exports = __webpack_public_path__ + "static/img/gg2.56f01d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gg2.png
// module id = 8sp0
// module chunks = 1